let t = null;
const r = () => {
  if (!document.querySelector(".yotpo-widget-instance")) return;
  t !== null && (window.clearInterval(t), t = null);
  let n = 0;
  const l = 20, e = () => {
    n += 1;
    const i = window.yotpoWidgetsContainer;
    if (typeof (i == null ? void 0 : i.initWidgets) == "function") {
      i.initWidgets(), t !== null && (window.clearInterval(t), t = null);
      return;
    }
    n >= l && t !== null && (window.clearInterval(t), t = null);
  };
  requestAnimationFrame(e), t = window.setInterval(e, 250);
};
export {
  r as i
};
